import React from "react";

import { CombinedReducerStore } from "../store";

export function wrapCurrentUser(Component) {
  return class WrapCurrentUserComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        currentUser: CombinedReducerStore.getState().loginReducers.currentUser,
        signedIn: CombinedReducerStore.getState().loginReducers.signedIn,
        provider: CombinedReducerStore.getState().loginReducers.provider
      };
    }

    componentDidMount() {
      CombinedReducerStore.subscribe(() => this.setState({currentUser: CombinedReducerStore.getState().loginReducers.currentUser,
                                           signedIn: CombinedReducerStore.getState().loginReducers.signedIn,
                                           provider: CombinedReducerStore.getState().loginReducers.provider}, () => {
					     if (this.state.currentUser) {
                  window.parent.postMessage({message: "metype_logged_in_user", ...this.state.currentUser}, "*");
					     }
					   }))
    }

    render() {
      return React.createElement(Component, {currentUser: this.state.currentUser,
                                                      signedIn: this.state.signedIn,
                                                      provider: this.state.provider, ...this.props});
    }
  }
};



// WEBPACK FOOTER //
// ./app/javascript/mixins/wrap_current_user.js